import { Textarea as KeychaineTextarea } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, FormLabel, FormWarning } from '../..';
export { KeychaineTextarea };
const Textarea = React.forwardRef(({ name, register, errors, labelText, handleChange, helperText, ...rest }, ref) => {
    const { ref: registerRef, ...registerRest } = register(name);
    const { setValue } = useFormContext();
    const onChange = (e) => {
        setValue(name, e.target.value, { shouldValidate: true });
        handleChange && handleChange(e);
    };
    return (React.createElement(FormControl, null,
        labelText && (React.createElement(FormLabel, { id: name + 'label', key: name + 'label' }, labelText)),
        React.createElement(KeychaineTextarea, { ref: (e) => {
                registerRef(e);
                if (ref) {
                    ref.current = e;
                }
            }, isInvalid: errors[name] && true, ...registerRest, ...rest, onChange: onChange, "aria-labelledby": labelText ? name + 'label' : undefined }),
        helperText && !errors[name] && React.createElement(FormHelperText, { key: 'sub-label' + name }, helperText),
        errors[name] && React.createElement(FormWarning, null, errors[name].message)));
});
Textarea.displayName = 'textarea';
export { Textarea };
